<template>
	<div class="index nobg" v-loading="loading">
		<HeaderInc ref="ref_header" :info="info"></HeaderInc>
		<div class="warp main_body">
			<div class="left_mune">
				<ul>
					<li @click="gohome">
						<img src="../assets/ico_3.png" />
						个人设置
					</li>
					<li @click="gowork">
						<img src="../assets/ico_4.png" />
						作品管理
					</li>
					<li class="active">
						<img src="../assets/ico_7.png" />
						证书查询
					</li>
				</ul>
			</div>
			<div class="main_content">
				<h1>>证书查询</h1>
				<div class="main_content_g">
					<el-table :data="tableData" border style="width: 100%">
						<el-table-column prop="year" label="年份" width="100" />
						<el-table-column prop="group_name" label="组别" width="100"></el-table-column>
						<el-table-column label="赛道" width="100">
							<template #default="scope">
								<span>{{wtype_option[scope.row.year][scope.row.wtype]}}</span>
							</template>
						</el-table-column>
						
						<el-table-column label="奖项" width="100">
							<template #default="scope">
								<span>{{scope.row.division_name}}赛区{{rank_options[scope.row.jxrank]}}</span>
							</template>
						</el-table-column>
						
						<el-table-column prop="cercode" label="证书编号" width="280" />
						<el-table-column prop="work_title" label="作品" width="250" />
						<el-table-column prop="people" label="作者" width="120" />
						<el-table-column prop="teacher_name" label="指导老师" width="120" />
						<el-table-column prop="school_name" label="学校" width="200" />
						<el-table-column fixed="right" label="获奖证书" width="140">
							<template #default="scope">
								<a class="button_1" style="display: inline-block; margin-right:10px;" @click="viewcer(scope.$index)">查看证书</a>
							</template>
						</el-table-column>
					</el-table>
				</div>
			</div>
		</div>

		<el-dialog v-model="cerbox_show" title="证书查看" width="100%" top="0" center>
			<div class="cerbox" id="cerbox" ref="cerbox" :style="{'width':cerinfo.width,'height':cerinfo.height}">
				<template v-for="item in cerinfo_po">
					<span :style="{'fontSize':item.num1,'marginLeft':item.num2,'marginTop':item.num3}" :class="item.name+' '+item.out">
						{{cerxuanran(item.name)}}
					</span>
				</template>
				<img :src="cerinfo.cnimage" style="pointer-events: none" />
			</div>
			<template #footer>
				<span class="dialog-footer">
					<el-button @click="cerbox_show = false">关闭</el-button>
					<el-button type="primary" @click="downcer">下载</el-button>
				</span>
			</template>
		</el-dialog>

	</div>
</template>

<script>
	import httpUtil from '@/util/HttpRequestUtil'
	import HeaderInc from '@/components/HeaderInc.vue'
	export default {
		name: 'Cer',
		components: {
			HeaderInc
		},
		props: {},
		data() {
			return {
				loading: true,
				info: {
					token: '',
					avatar: '',
					name: ''
				},
				tableData: [],
				group_option: ['专业组', '学生组', '设计师组'],
				wtype_option: [],
				cerbox_show: false,
				cerdata: [],
				cerinfo: [],
				cerinfo_po: [],
				options: ['图片','图片','音频视频','论文'],
				rank_options: ['未获奖','一等奖','二等奖','三等奖','优秀奖','学术奖','东方金鹤奖','东方黄鹤奖','入选奖','入围奖','优秀作品','入选作品'],
				en_option: ['','First Prize','Second Prize','Third Prize','Prize','Prize','Prize','Prize','Prize','Prize','Excellent Works','Selected','Finalist']
			}
		},
		created() {
			this.getuserdata();
			this.getfmtoption();
		},
		updated() {

		},
		activated() {

		},
		deactivated() {

		},
		methods: {
			getuserdata() {
				var that = this
				var userinfo = JSON.parse(localStorage.getItem('userinfo')) || [];
				if (!userinfo.token) {
					that.gologin()
					return false
				}
				let data = {}
				data.ac = 'getuserinfo'
				data.token = userinfo.token
				httpUtil.post('/api/', data, function(res) {
					if (res) {
						if (res.status == 1) {
							that.info = res
							that.info.type = parseInt(res.type)
							that.getcerlist()
							that.loading = false
						} else {
							that.$message.error('请先完成注册~')
							that.gohome()
						}
					} else {
						that.gologin()
						return false
					}
				})
			},
			getfmtoption(){
				var that = this
				let data = {}
				data.ac = 'getfmtcer'
				httpUtil.post('/api/', data, function(res) {
					that.wtype_option = res;
				})
			},
			getcerlist() {
				var that = this
				let data = {}
				data.ac = 'getcerlist'
				data.token = that.info.token
				httpUtil.post('/api/', data, function(res) {
					if (res) {
						that.tableData = res
					}
				})
			},
			viewcer(index) {
				var that = this
				that.cerdata = that.tableData[index]
				if(that.cerdata.work_title.length > 18 && that.cerdata.division_name == '全国'){
					that.cerdata.out = 'out_g'
				}else if(that.cerdata.work_title.length > 18 && that.cerdata.division_name != '全国'){
					that.cerdata.out = 'out'
				}else{
					that.cerdata.out = ''
				}
				
				that.cerdata.winrank = that.cerdata.jxrank
				let data = {}
				data.ac = 'getcerinfo'
				data.year = that.cerdata.year
				data.type = that.cerdata.division_name == '全国'?1:4
				data.match_id = that.cerdata.match_id
				httpUtil.post('/api/', data, function(res) {
					if (res) {
						that.cerinfo = res;
						let newjson = JSON.parse(res.txt);
						for(let i in newjson){
							newjson[i].out = '';
							if(newjson[i].name == 'work_title'){
								if(that.cerdata.work_title.length > 18 && that.cerdata.division_name == '全国'){
									newjson[i].out = 'out_g'
								}else if(that.cerdata.work_title.length > 18 && that.cerdata.division_name != '全国'){
									newjson[i].out = 'out'
								}
							}
							if(newjson[i].name == 'people'){
								if(that.cerdata.people.length > 18 && that.cerdata.division_name == '全国'){
									newjson[i].out = 'out_g'
								}else if(that.cerdata.people.length > 18 && that.cerdata.division_name != '全国'){
									newjson[i].out = 'out'
								}
							}
							if(newjson[i].name == 'match_title'){
								if(that.cerdata.match_title.length > 13 && that.cerdata.division_name == '全国'){
									newjson[i].out = 'out_g'
								}
							}
							
						}
						that.cerinfo_po = JSON.parse(res.txt);
						that.cerbox_show = true
					}
				})
			},
			cerxuanran(str){
				var that = this
				let namearr = ['jxrank','wtype','division_name','enrank']
				let cindex = namearr.indexOf(str)
				if(cindex == 1){
					return that.wtype_option[that.cerdata.year][that.cerdata[str]]
				}else if(cindex == 0){
					return that.rank_options[that.cerdata[str]]
				}else if(cindex == 2){
					if(that.cerdata.division_name != '全国'){
						return that.cerdata[str]+'赛区';
					}
				}else if(cindex == 3){
					return that.en_option[that.cerdata['jxrank']]
				}else{
					return that.cerdata[str]
				}
			},
			downcer(){
				var that = this
				let cntElem = that.$refs.cerbox
				let shareContent = cntElem
				let width = shareContent.offsetWidth
				let height = shareContent.offsetHeight
				let canvas = document.createElement('canvas')
				let scale = 1190 / width
				canvas.width = width * scale
				canvas.height = height * scale
				canvas.getContext('2d').scale(scale, scale)
				let ops = {
					scale: 1,
					canvas:canvas,
					width: 1190,
					height: 1666,
					logging:false,
					useCORS: true
				}

				html2canvas(shareContent,ops).then(canvas => {
					let link = document.createElement("a");
					link.href = canvas.toDataURL('image/jpeg', 1);//下载链接
					link.setAttribute("download","cer.jpg");
					link.style.display = "none";//a标签隐藏
					document.body.appendChild(link);
					link.click();
				});
			},
			gohome() {
				var that = this
				that.$router.isBack = true
				that.$router.push({
					name: 'Home'
				})
			},
			gowork() {
				var that = this
				that.$router.isBack = true
				that.$router.push({
					name: 'Work'
				})
			},
			gologin() {
				var that = this
				that.$router.isBack = true
				that.$router.push({
					name: 'Index'
				})
			},
		},

	}
</script>

<style>
	.cerbox {
		display: block;
		margin: 0 auto;
	}
	
	.cerbox span{
		display: block;
		position: absolute;
		width: auto;
		color: #a07d24;
		font-family: 'syht';
		letter-spacing: 2px;
	}
	
	.cerbox img{
		display: block;
		width: 100%;
		height: 100%;
	}
	
	.cerbox span.jxrank,.cerbox span.enrank{
		color: #c8000b;
		font-weight: bold;
		font-family: 'syst';
		letter-spacing: 2px;
	}

	.cerbox span.cercode{
		color: #c8000b;
		font-weight: 500;
		font-family: 'syst';
		letter-spacing: 0px;
	}
	.cerbox span.division_name{
		color: #c8000b;
		font-weight: 500;
		font-family: 'syht';
		letter-spacing: 0px;
	}

	.cerbox span.work_title.out{
		width: 280px;
		text-overflow:ellipsis;
		line-height: 1;
		margin-top: 485px !important;
	}
	
	.cerbox span.work_title.out_g{
		width: 250px;
		text-overflow:ellipsis;
		line-height: 1;
		margin-top: 528px !important;
	}
	
	.cerbox span.people.out{
		width: 280px;
		text-overflow:ellipsis;
		line-height: 1;
		margin-top: 545px !important;
	}
	
	.cerbox span.people.out_g{
		width: 250px;
		text-overflow:ellipsis;
		line-height: 1;
		margin-top: 575px !important;
	}
	
	.cerbox span.match_title.out_g{
		width: 250px;
		text-overflow:ellipsis;
		line-height: 1;
		margin-top: 538px !important;
	}
	
</style>
